export const MENU = [
  {
    "label": "Home",
    "href": "/"
  },
  {
    "label": "About",
    "href": "/about"
  },
  {
    "label": "Products",
    "children": [
      {
        "label": "All products",
        "href": "/shop"
      },
      {
        "label": "Christmas & Seasonal",
        "href": "/collections/christmas-seasonal"
      },
      {
        "label": "Candleholders & Lanterns",
        "href": "/collections/candleholders-lanterns"
      },
      {
        "label": "Decorative Objects",
        "href": "/collections/decorative-objects"
      },
      {
        "label": "Trays & Serveware",
        "href": "/collections/trays-serveware"
      },
      {
        "label": "Wood & Marble",
        "href": "/collections/wood-marble"
      },
      {
        "label": "Accent Furniture",
        "href": "/collections/accent-furniture"
      }
    ]
  },
  {
    "label": "Craftsmanship",
    "href": "/about#craftsmanship"
  },
  {
    "label": "Export enquiries",
    "href": "/contact"
  },
  {
    "label": "FAQs",
    "href": "/pages/faq"
  },
  {
    "label": "Request Catalogue",
    "href": "/catalogue"
  },
  {
    "label": "Trade Fairs",
    "href": "/trade-fairs"
  },
  {
    "label": "Compliance",
    "href": "/compliance"
  },
  {
    "label": "Enquiry Basket",
    "href": "/cart"
  }
];

export const FOOTER_LINKS = [
  {
    "label": "Export enquiries",
    "href": "/contact"
  },
  {
    "label": "Buyer FAQs",
    "href": "/pages/faq"
  },
  {
    "label": "Catalogue terms",
    "href": "/pages/terms"
  },
  {
    "label": "Privacy",
    "href": "/pages/privacy"
  },
  {
    "label": "Catalogue",
    "href": "/catalogue"
  },
  {
    "label": "Trade Fairs",
    "href": "/trade-fairs"
  },
  {
    "label": "Compliance",
    "href": "/compliance"
  }
];

export const CATEGORY_SKETCH = {
  Lighting: "/assets/sketches/lighting.png",
  "Home Décor": "/assets/sketches/decor.png",
  Tabletop: "/assets/sketches/tabletop.png",
  Accessories: "/assets/sketches/accessories.png",
  Gifting: "/assets/sketches/gifting.png",
};

export const HOME_COLLECTIONS = [
 {slug:"christmas-seasonal",name:"Christmas & Seasonal",sketch:"/assets/sketches/gifting.png"},
 {slug:"candleholders-lanterns",name:"Candleholders & Lanterns",sketch:"/assets/sketches/lighting.png"},
 {slug:"decorative-objects",name:"Decorative Objects",sketch:"/assets/sketches/decor.png"},
 {slug:"trays-serveware",name:"Trays & Serveware",sketch:"/assets/sketches/tabletop.png"},
 {slug:"wood-marble",name:"Wood & Marble",sketch:"/assets/sketches/accessories.png"},
 {slug:"accent-furniture",name:"Accent Furniture",sketch:"/assets/sketches/decor.png"}
];
